import { lazy } from 'react';
import { Route } from 'react-router-dom';

const NanoBananaLayout = lazy(() => import('../nanobanana/_components/layout'));
const ShowcasePage = lazy(() => import('../nanobanana/showcase/page'));
const PromptsPage = lazy(() => import('../nanobanana/prompts/page'));

export const NanoBananaRoutes = (
  <Route element={<NanoBananaLayout />}>
    <Route path="/" element={<ShowcasePage />} />
    <Route path="/showcase" element={<ShowcasePage />} />
    <Route path="/prompts" element={<PromptsPage />} />
  </Route>
);
